import { StripeCoupon } from "@cruisen/contract"

export const calculateDiscountedPrice = (price: number, discount: StripeCoupon | null): number => {
  if (!discount) return price

  const discountAmountOff = discount.amount_off ? discount.amount_off / 100 : 0
  const discountPercentOff = discount.percent_off ?? 0

  if (discountAmountOff) {
    return price - discountAmountOff
  } else if (discountPercentOff) {
    return (price / 100) * (100 - discountPercentOff)
  }

  return price
}
